import "./App.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useDispatch } from "react-redux";
import * as React from "react";
import { Fragment, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login/login";
import secureLocalStorage from "react-secure-storage";
import ResetPassword from "./pages/Login/ResetPassword";
import { getAllUsers, updateUser } from "./actions/user";
import NotFound from "./pages/Not Found/NotFound";
import ResetMyPassword from "./user page/ResetPassword";
import { getAllInvestment } from "./actions/investment";
import { getAllInvestmentTypes } from "./actions/investmentType";
import { getAllRegulators } from "./actions/regulator";
import { approvedInvestments } from "./actions/approvedInvestment";
import { newInvestments } from "./actions/newInvestments";
import { yearStats } from "./actions/yearStats";
import { monthStats } from "./actions/monthStats";
import { approvedUndefinedInvestments } from "./actions/approvedUndefinedInvestments";
import InternetConnectionMonitor from "./pages/Internet Connection/InternetConnection";
import { getUndefinedInvestments } from "./actions/undefinedRate";
import Analytics from "./pages/Insight/Insight";
import { getImpairedInvestments } from "./actions/impairment";
import Restrict from "./pages/Restrict/Restrict";
import { Toaster } from "react-hot-toast";
import AppLayout from "./ui/AppLayout";
import ProtectedRoute from "./ui/ProtectedRoute";
import { getInstitutionStats } from "./actions/institutionStats";
import { getAllInstitution } from "./actions/institution";
import { getRedeemedInvestments } from "./actions/redemption";
import TimeZoneCheckerModal from "./TimeZoneCheck/TimeZone";
import { PAGES, REDIRECTS } from "./navigation";
const App = () => {
  const initialState = JSON.parse(secureLocalStorage.getItem("profile"));
  const [user, setUser] = React.useState(initialState);

  useEffect(() => {
    setUser(JSON.parse(secureLocalStorage.getItem("profile")));
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    if (user) {
      dispatch(getAllUsers());
      dispatch(getAllInvestment());
      dispatch(getAllInvestmentTypes());
      dispatch(getAllRegulators());
      dispatch(approvedInvestments());
      dispatch(newInvestments());
      dispatch(yearStats());
      dispatch(monthStats());
      dispatch(getUndefinedInvestments());
      dispatch(approvedUndefinedInvestments());
      dispatch(getImpairedInvestments());
      dispatch(getInstitutionStats());
      dispatch(getAllInstitution());
      dispatch(getRedeemedInvestments());
    }
  }, [dispatch, user]);
  React.useEffect(() => {
    if (user) {
      dispatch(
        updateUser(user?.results._id, {
          login: "yes",
          system: "investment",
        }),
      );
    }
  }, [dispatch, user]);
  return (
    <HelmetProvider>
      <TimeZoneCheckerModal />
      {user?.results.portfolio_manager === "Restricted" ? (
        <Restrict />
      ) : (
        <div className="App">
          <Fragment>
            <InternetConnectionMonitor />
            <Routes>
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Analytics />} />
                {PAGES.map((page) => (
                  <Route
                    key={page.path}
                    path={page.path}
                    element={
                      <>
                        <Helmet title={`${page.title} | Portfolio Manager`} />
                        {page.element}
                      </>
                    }
                  />
                ))}
                {Object.entries(REDIRECTS).map(([from, to]) => (
                  <Route
                    key={from}
                    path={from}
                    element={<Navigate to={to} replace />}
                  />
                ))}
              </Route>
              <Route path="/investment/login" element={<Login />} />
              <Route
                path="/investment/resetPassword"
                element={<ResetPassword />}
              />
              <Route
                path="/investment/resetMyPassword/:token"
                element={<ResetMyPassword />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Fragment>
        </div>
      )}
      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 6000,
          },
          style: {
            fontSize: "14px",
            maxWidth: "500px",
            padding: "10px 20px",
            backgroundColor: "#555",
            color: "#fff",
          },
        }}
      />
    </HelmetProvider>
  );
};

export default App;
